import React from 'react'

import { UserAttributeDisplay } from 'features/views/attributes/UserAttributeDisplay'

import { Box } from 'ui/components/Box'
import { Field } from 'ui/components/Field'
import { RootStyles } from 'ui/components/Input/Input.css'

import { SectionAttributeEditorProps } from './types'

type SectionUserAttributeEditorProps = SectionAttributeEditorProps<UserRefDto>

export const SectionUserAttributeEditor: React.FC<SectionUserAttributeEditorProps> = ({
    label,
    value,
    field,
}) => {
    // This field type is never editable, so we don't need to show an editor.
    return (
        <Field label={label}>
            <Box
                className={RootStyles.styleFunction({
                    isReadOnly: true,
                    size: 'm',
                    variant: 'default',
                })}
            >
                {value && (
                    <UserAttributeDisplay
                        value={value}
                        field={field}
                        size="m"
                        style={{
                            pointerEvents: 'none',
                        }}
                        maxWidth="full"
                        minWidth={0}
                        trim
                    />
                )}
            </Box>
        </Field>
    )
}
